import React from "react";
import { Tooltip } from "@chakra-ui/react";
import styled from "styled-components";

interface GuaranteedHoursCellProps {
	guaranteedHours?: {
		actualHours: number;
		guaranteedHours: number;
		remainingHours: number;
		isComplete: boolean;
	};
}

const HoursText = styled.span<{ isComplete: boolean }>`
	font-size: 14px;
	font-weight: ${(props) => (props.isComplete ? "400" : "600")};
	color: ${(props) => (props.isComplete ? "inherit" : "#d32f2f")};

	/* Roomy screens step up with the Tailwind type scale (.type-body) */
	@media (min-width: 1280px) {
		font-size: 15px;
	}
	@media (min-width: 1536px) {
		font-size: 16px;
	}
`;

const TooltipContent = styled.div`
	text-align: left;
	font-size: 13px;
	line-height: 1.6;

	.row {
		display: flex;
		justify-content: space-between;
		margin-bottom: 4px;
		gap: 16px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.label {
		color: rgba(255, 255, 255, 0.8);
	}

	.value {
		font-weight: 500;
		color: white;
	}

	.separator {
		margin: 8px 0;
		border-top: 1px solid rgba(255, 255, 255, 0.2);
	}
`;

const GuaranteedHoursCell: React.FC<GuaranteedHoursCellProps> = ({ guaranteedHours }) => {
	if (!guaranteedHours) {
		return <span>-</span>;
	}

	const { actualHours, guaranteedHours: required, remainingHours, isComplete } = guaranteedHours;
	const surplus = actualHours - required;

	return (
		<Tooltip
			label={
				<TooltipContent>
					<div className="row">
						<span className="label">Arbetade timmar:</span>
						<span className="value">{actualHours} h</span>
					</div>
					<div className="row">
						<span className="label">Garantitid:</span>
						<span className="value">{required} h</span>
					</div>
					<div className="separator" />
					<div className="row">
						<span className="label">{isComplete ? "Överskott:" : "Återstår:"}</span>
						<span className="value">{isComplete ? `+${surplus} h` : `-${remainingHours} h`}</span>
					</div>
				</TooltipContent>
			}
			placement="top"
			hasArrow
			bg="gray.700"
			color="white"
			px={3}
			py={2}
			borderRadius="md"
		>
			<HoursText isComplete={isComplete}>
				{isComplete ? `+${surplus} h` : `-${remainingHours} h`}
			</HoursText>
		</Tooltip>
	);
};

export default GuaranteedHoursCell;
